import I18n from "../../awrabet/utils/localization";
export * from "../../awrabet/utils/localization";
export default I18n;